module.exports = function (element) {
    function commentBlock(el) {
        var pr = 0;
        var node = $(el);
        var otvs = node.find(".js-comment-otv");
        var form = node.find("form");

        otvs.on({
            click: function () {
                var id = $(this).attr('href').slice(1);

                $('#' + pr).empty();
                $("a[href^='#" + pr + "']").show();
                $(this).hide();

                var com = '<textarea name="body" rows="3"></textarea>' +
                    '<input name="parent" type="hidden" value="' + id + '">' +
                    '<input type="submit" value="Написать" id="comment-btn">';

                pr = id;
                $('#' + pr).html(com);
                $('.comment_form').find('textarea').focus()
                $('#' + pr).parent().find('.comment__del').remove();

                return false;
            }
        });

        form.on({
            submit: function (event) {
                event.preventDefault();
                event.stopPropagation();

                var frForm = $(this).serialize();

                $.post(form.attr('action'), frForm, function (data) {
                    var frm = $('#' + data.result.parent);
                    frm.empty();
                    $("a[href^='#" + data.result.parent + "']").show();

                    var body = '<div class="comment">' +
                        '<div class="comment__top">' +
                        '<div class="user_block">' +
                        '<div class="user_block__avatar">' +
                        '<img src="' + data.result.avatar + '" width="32" height="32" border="0">' +
                        '</div>' +
                        '<div class="user_block__user">' +
                        '<span>' + data.result.user + '</span> сейчас' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '<div class="comment__bottom">' + data.result.body + '</div>' +
                        '</div>';

                    if (data.result.parent != 0)
                        frm.parent().after('<br clear="all">' + body);
                    else
                        frm.html(body + '<br clear="all">');

                    gtag('event', 'comment_add', {
                        'event_category': 'comment'
                    });
                }, 'json');

                return false;
            }
        });

        $("body").on("mouseenter", ".comment", function () {
            $("a[href*='/comment/delete/']", this).show()
        }).on("mouseleave", ".comment", function () {
            $("a[href*='/comment/delete/']", this).hide()
        });

        $(".comment__hidden").on({
            mouseenter:
                function () {
                    $(this).stop().animate({"opacity": 1}, 1000);
                },
            mouseleave:
                function () {
                    $(this).stop().animate({"opacity": 0.3}, 800);
                }
        });

        $(".comment__del").on("click", function () {
            $(this).parent().hide();
            $.get($(this).attr('href'));

            gtag('event', 'comment_remove', {
                'event_category': 'comment'
            });

            return false;
        });
    }

    if (!element) {
        throw new Error('Element undefined');
    }

    commentBlock(element);
};